{
  "test-app": {
    "id": "",
    "devOnly": true,
    "hide": true,
    "appNameDefaultText": "Test App",
    "free": true,
    "acceptsFileTransfer": true
  },
  "tx-recv-demo": {
    "id": "/mesh-rx.html",
    "appNameDefaultText": "Mesh Receive",
    "devOnly": true
  },
  "tx-send-demo": {
    "id": "/mesh-tx.html",
    "appNameDefaultText": "Mesh Send",
    "devOnly": true,
    "hide": true,
    "acceptsFileTransfer": false
  },
  "robotic-fingers": {
    "id": "robotic-fingers",
    "appNameDictKey": "home.appcard.title.robotic-fingers",
    "appNameDefaultText": "Robotic Fingers",
    "descriptionDictKey": "home.appcard.description.robotic-fingers",
    "theme": "bright",
    "categories": ["hold-grip-position"],
    "appUrl": "apps/robotic-fingers",
    "cardImage": "assets/img/app-cards/gradient/jpg/Robotic-Fingertips.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/robotic-fingers",
    "free": false,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true
    }
  },
  "clamping": {
    "id": "clamping",
    "appNameDictKey": "home.appcard.title.clamping",
    "appNameDefaultText": "Clamping",
    "descriptionDictKey": "home.appcard.description.clamping",
    "theme": "dark",
    "categories": ["hold-grip-position"],
    "appUrl": "apps/clamping",
    "cardImage": "assets/img/app-cards/gradient/jpg/Clamping.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/clamping-jaws",
    "free": false,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true
    }
  },
  "shadow-boards": {
    "id": "shadow-boards",
    "appNameDictKey": "home.appcard.title.traysShadowBoards",
    "appNameDefaultText": "Shadow-board",
    "descriptionDictKey": "home.appcard.description.traysShadowBoards",
    "theme": "dark",
    "categories": ["store-organize", "pack-transport"],
    "appUrl": "apps/shadow-boards",
    "cardImage": "assets/img/app-cards/gradient/jpg/Shadow-Board.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/shadow-boards",
    "free": false,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true
    }
  },
  "outlines": {
    "id": "outlines",
    "appNameDictKey": "home.appcard.title.outlines",
    "appNameDefaultText": "Outline",
    "descriptionDictKey": "home.appcard.description.outlines",
    "theme": "dark",
    "categories": ["prepare-modify"],
    "appUrl": "apps/outlines",
    "cardImage": "assets/img/app-cards/gradient/jpg/Photo-to-outline.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/photo-to-outline",
    "free": true,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true
    }
  },
  "workpiece-creator": {
    "id": "workpiece-creator",
    "appNameDictKey": "home.appcard.title.workpiece-creator",
    "appNameDefaultText": "Part Sketcher",
    "descriptionDictKey": "home.appcard.description.workpiece-creator",
    "theme": "light",
    "categories": ["prepare-modify"],
    "appUrl": "apps/workpiece-creator",
    "cardImage": "assets/img/app-cards/gradient/jpg/Part-Sketcher.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/part-sketcher",
    "free": true,
    "acceptsFileTransfer": true,
    "visibility": {
      "staging": true,
      "production": true
    },
    "stickerTag": "beta"
  },
  "workpiece-modifier": {
    "id": "workpiece-modifier",
    "appNameDictKey": "home.appcard.title.workpiece-modifier",
    "appNameDefaultText": "Workpiece Modifier",
    "descriptionDictKey": "home.appcard.description.workpiece-modifier",
    "theme": "light",
    "categories": ["prepare-modify"],
    "appUrl": "apps/workpiece-modifier",
    "cardImage": "assets/img/app-cards/gradient/jpg/Part-Modifier.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/part-modifier",
    "free": true,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true
    }
  }
}
